import { Component, OnInit } from '@angular/core';
import { Pf16Service } from 'src/app/services/pf16.service';

@Component({
  selector: 'app-pf16-interpretation',
  templateUrl: './pf16-interpretation.component.html',
  styles: [
  ]
})
export class Pf16InterpretationComponent implements OnInit {

  public interpretations=[];

  constructor(private pf16Service:Pf16Service) {

    this.pf16Service.getInterpretations().subscribe(
      resp=>{
        this.interpretations = resp;
      },
      err=>console.log(err)
    )

  }

  ngOnInit(): void {
  }


  handleDelete(id){
    console.log(id)
  }

  handleEdit(interp){
    console.log(interp)
  }

}
